import React, { useRef, useContext, useState } from 'react';
import { ThemeContext } from 'styled-components';

import useMount from 'ggApp/shared/hooks/useMount';
import useUnmount from 'ggApp/shared/hooks/useUnmount';
import {
    NextArrowIcon,
    PrevArrowIcon,
    TopControlButtonsWrapper,
    Slider,
    ControlButton,
} from './styles';

const CategoriesSlider = ({ children, isMobile = false }) => {
    const [prevButtonDisabled, setPrevButtonDisabled] = useState(true);
    const [isNavButtonVisible, setIsNavButtonVisible] = useState(true);

    const simpleBarRef = useRef(null);
    const theme = useContext(ThemeContext);

    const onSimpleBarScroll = () => {
        if (simpleBarRef && simpleBarRef.current) {
            const scrollElement = simpleBarRef.current.getScrollElement();

            setPrevButtonDisabled(scrollElement.scrollLeft <= 0);
        }
    };

    const checkNavButtonVisibility = () => {
        if (simpleBarRef && simpleBarRef.current) {
            const contentElement = simpleBarRef.current.getContentElement();
            const scrollElement = simpleBarRef.current.getScrollElement();

            setIsNavButtonVisible(scrollElement.scrollWidth > contentElement.offsetWidth);
        }
    };

    useMount(() => {
        window.addEventListener('resize', onSimpleBarScroll);
        window.addEventListener('resize', checkNavButtonVisibility);

        if (simpleBarRef && simpleBarRef.current) {
            const scrollElement = simpleBarRef.current.getScrollElement();

            scrollElement.addEventListener('scroll', onSimpleBarScroll);
        }
    });

    useUnmount(() => {
        window.removeEventListener('resize', onSimpleBarScroll);
        window.removeEventListener('resize', checkNavButtonVisibility);

        if (simpleBarRef && simpleBarRef.current) {
            const scrollElement = simpleBarRef.current.getScrollElement();

            scrollElement.removeEventListener('scroll', onSimpleBarScroll);
        }
    });

    const goNext = () => {
        if (simpleBarRef && simpleBarRef.current) {
            const scrollElement = simpleBarRef.current.getScrollElement();
            const contentElement = simpleBarRef.current.getContentElement();

            const {
                scrollWidth,
                scrollLeft,
                clientWidth,
            } = simpleBarRef.current.getScrollElement();

            const isEndReached = scrollWidth - Math.round(scrollLeft) === clientWidth;

            scrollElement.scrollTo({
                left: isEndReached ? 0 : scrollElement.scrollLeft + contentElement.clientWidth,
                behavior: 'smooth',
            });
        }
    };

    const goPrev = () => {
        if (simpleBarRef && simpleBarRef.current) {
            const scrollElement = simpleBarRef.current.getScrollElement();
            const contentElement = simpleBarRef.current.getContentElement();

            scrollElement.scrollTo({
                left: scrollElement.scrollLeft - contentElement.clientWidth,
                behavior: 'smooth',
            });
        }
    };

    if (children?.length === 0) return null;

    return (
        <>
            {!isMobile && isNavButtonVisible ? (
                <TopControlButtonsWrapper>
                    <ControlButton
                        onClick={goPrev}
                        disabled={prevButtonDisabled}
                        icon={
                            <PrevArrowIcon
                                color={
                                    prevButtonDisabled
                                        ? theme.colors['Level 4']
                                        : theme.colors.Foreground
                                }
                            />
                        }
                    />
                    <ControlButton onClick={goNext} icon={<NextArrowIcon />} />
                </TopControlButtonsWrapper>
            ) : null}
            <Slider data-testid="categories-slider" ref={simpleBarRef} autoHide={false}>
                {children}
            </Slider>
        </>
    );
};

export default CategoriesSlider;
